import { styled, Tabs } from "@mui/material";

export const UsageTypeTabs = styled(Tabs)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;
